export default "__VITE_ASSET__EJn7TdqJ__"